import { type FC } from 'react'

import {
  CROSS_SELL_CART_INTERMEDIATE_SPECIAL_OFFERS,
  CrossSellGrid,
  CrossSellWidgetContainer,
  useCrossSellConfigContext,
  useCrossSellIntersection,
  useCrossSellWidgetTitle,
  useSwrCrossSellHorizontalSlider,
} from '../../../cross-sell'
import { gtmDataLayerPushCswProduct } from '../../../gtm'
import { useCartIntermediateContext } from '../../hooks/useCartIntermediateContext'

import { CartIntermediateSpecialOffersCrossSellProductCard } from './CartIntermediateSpecialOffersCrossSellProductCard'

export const CartIntermediateSpecialOffersCrossSellWidget: FC = () => {
  const { widgets } = useCrossSellConfigContext()
  const { entries } = useCartIntermediateContext()

  const product = entries?.at(0)

  const { handleIntersection, intersected } = useCrossSellIntersection()

  const widgetId = widgets[CROSS_SELL_CART_INTERMEDIATE_SPECIAL_OFFERS]?.id

  const { data, error } = useSwrCrossSellHorizontalSlider(
    intersected && widgetId
      ? {
          productId: product?.id,
          widgetId,
        }
      : undefined,
  )
  const widgetTitle = useCrossSellWidgetTitle({
    data,
    widgetType: CROSS_SELL_CART_INTERMEDIATE_SPECIAL_OFFERS,
  })

  if (!widgetId || data?.items.length === 0 || error) {
    return null
  }

  return (
    <CrossSellWidgetContainer
      onIntersect={handleIntersection}
      widgetData={data}
      widgetId={widgetId}
      widgetType={CROSS_SELL_CART_INTERMEDIATE_SPECIAL_OFFERS}
    >
      <CrossSellGrid
        onGtmDataLayerPush={(cswProductId) => {
          gtmDataLayerPushCswProduct({
            cswProductId,
            productId: product?.id,
            widgetId,
            widgetTitle,
          })
        }}
        products={data?.items}
        slotProps={{
          itemList: {
            className:
              'grid w-full grid-cols-1 gap-4 tablet:grid-cols-2 tablet:gap-y-6',
          },
        }}
        slots={{
          itemContent: CartIntermediateSpecialOffersCrossSellProductCard,
        }}
      />
    </CrossSellWidgetContainer>
  )
}
